<template>
  <span
    class="inline-block flex-1 overflow-hidden text-ellipsis whitespace-nowrap px-2 text-sm font-medium text-white/70"
  >
    <span v-if="hasCurrentChapter || title" class="mr-1">•</span>
    <span v-else class="mr-1">{{title}}</span>
    <media-chapter-title ref="mediaChapterTitle"/>
  </span>
</template>


<script setup>
import {inject, onMounted, onUnmounted, ref} from "vue";

const observer = ref(null);
const mediaChapterTitle = ref(null);
const hasCurrentChapter = ref(false);

const title = inject("title");

onMounted(() => {
  const callback = (mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "childList") {
        hasCurrentChapter.value = !!mediaChapterTitle.value.innerText;
      }
    }
  };

  observer.value = new MutationObserver(callback);
  observer.value.observe(mediaChapterTitle.value, {childList: true});
});

onUnmounted(() => {
  if (observer.value) observer.value.disconnect();
});
</script>
